import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type { IPostData, IPostListItem, IResponsePostList } from '~/modules/posts/types/posts';

export default class Posts extends AbstractFetch {
  private static readonly POST = 'v1/posts/';
  private static readonly POST_LIST = 'v1/posts/';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  /**
   * Получает запись по её уникальному идентификатору.
   *
   * @param {number} id - Уникальный идентификатор получаемой записи.
   * @return {Promise<IResponse<T>>} Промис, который разрешается ответом, содержащим данные записи.
   */
  async getPost<T>(id: number): Promise<IResponse<IPostData<T>>> {
    return this.fetch(Posts.POST + id);
  }

  /**
   * Получает список записей с указанного эндпоинта.
   *
   * @return {Promise<IResponse<IResponsePostList<IPostListItem[]>>>} Промис, который разрешается ответом, содержащим список записей.
   */
  async getPostList(): Promise<IResponse<IResponsePostList<IPostListItem[]>>> {
    return this.fetch(Posts.POST_LIST);
  }
}
